import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faSave, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Rebar.css';
import '../../Shared/Searchbar.css'; // Import your CSS file
import axios from "axios";
import GoCast from '../../Images/GoCast.png';
import { css } from '@emotion/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Rebar() {
    const [isCollapsed, setIsCollapsed] = useState(false); // Add this state

    const [searchOpen, setSearchOpen] = useState(false);
    const [tableVisible, setTableVisible] = useState(true);
    const [apiData, setApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Default items per page
    const [modifiedData, setModifiedData] = useState([]);
    const [modifiedRows, setModifiedRows] = useState(new Set());
    const [filter, setFilter] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const [showEmptyRow, setShowEmptyRow] = useState(false);
    const [job, setjob] = useState('');
    const [elementid, setelementid] = useState('');
    const [reinforcementid, setreinforcementid] = useState('');
    const [reinforcementdescription, setreinforcementdescription] = useState('');
    const [qty, setqty] = useState('');
    const [uom, setuom] = useState('');
    const [unit, setunit] = useState('');
    const [engineered, setengineered] = useState(false);
    const [released, setreleased] = useState(false);
    const [site, setsite] = useState(false);

    const handleFilterChange = (e) => {
        const inputValue = e.target.value.toLowerCase();
        setFilter(inputValue);
        const filteredData = apiData.filter(item => item.PartLot_LotNum && item.PartLot_LotNum.toLowerCase().includes(inputValue));
        setModifiedData(filteredData.map(item => ({ ...item })));
    };

    const fetchData = async () => {
        setIsLoading(true);
        const username = 'manager';
        const password = 'manager';
        const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_RebarElements_PCopy(PRECAST)';

        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (typeof data === 'object' && data !== null && Array.isArray(data.value)) {
                setApiData(data.value);
                setModifiedData(data.value.map(item => ({ ...item })));
                setIsLoading(false);
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data);
            }
        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const saveData = async () => {
        const username = 'manager';
        const password = 'manager';
        if (showEmptyRow) {
            const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UD102Svc/UD102s`;
            const newRow = {
                "Company": "PRECAST",
                "JobHead_JobNum": job,
                "PartLot_LotNum": elementid,
                "JobMtl_PartNum": reinforcementid,
                "JobMtl_Description": reinforcementdescription,
                "JobMtl_QtyPer": qty,
                "JobMtl_IUM": uom,
                "JobHead_ProdQty": unit,
                "JobHead_JobEngineered": engineered,
                "JobHead_JobReleased": released,
                "JobMtl_Plant": site
            };
            try {
                const response = await axios.post(apiUrl, newRow, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                setShowEmptyRow(false);
                toast.success("Data Saved Successfully");
            } catch (error) {
                console.error('Error:', error.message);
                toast.error("Failed To Save");
            }
        } else {
            setIsLoading(true);
            const apiUrl = 'https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_RebarElements_PCopy(PRECAST)';

            try {
                for (const rowIndex of modifiedRows) {
                    const response = await axios.patch(apiUrl, modifiedData[rowIndex], {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic ' + btoa(username + ":" + password)
                        }
                    });
                    toast.success("Data Saved Successfully");
                }
            } catch (error) {
                console.error('Error:', error.message);
                toast.error("Failed To Save");
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleInputChange = (e, index, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const newData = [...modifiedData];
        newData[index][field] = newValue;
        setModifiedData(newData);
        setModifiedRows(new Set(modifiedRows.add(index)));
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Reset to first page when changing items per page
    };

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, modifiedData.length);
        const currentItems = modifiedData.slice(startIndex, endIndex);

        return (
            <>
                {currentItems.map((item, index) => (
                    <tr key={startIndex + index}>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_JobNum} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_JobNum')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].PartLot_LotNum} onChange={(e) => handleInputChange(e, startIndex + index, 'PartLot_LotNum')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_PartNum} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_PartNum')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_Description} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_Description')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_QtyPer} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_QtyPer')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_IUM} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_IUM')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobHead_ProdQty} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_ProdQty')} /></td>
                        <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobEngineered} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_JobEngineered')} /></td>
                        <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobReleased} onChange={(e) => handleInputChange(e, startIndex + index, 'JobHead_JobReleased')} /></td>
                        <td><input className='UpdateInput' type="text" value={modifiedData[startIndex + index].JobMtl_Plant} onChange={(e) => handleInputChange(e, startIndex + index, 'JobMtl_Plant')} /></td>
                    </tr>
                ))}
                {showEmptyRow && (
                    currentItems.slice(startIndex, endIndex).map((item, index) => (
                        <tr key={`empty-row-${index}`}>
                            <td><input className='UpdateInput' type="text" placeholder="Job Num" value={modifiedData[startIndex + index].JobHead_JobNum} onChange={(e) => setjob(e, startIndex + index, 'JobHead_JobNum')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Element ID " value={modifiedData[startIndex + index].PartLot_LotNum} onChange={(e) => setelementid(e, startIndex + index, 'PartLot_LotNum')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Reinfocement ID" value={modifiedData[startIndex + index].JobMtl_PartNum} onChange={(e) => setreinforcementid(e, startIndex + index, 'JobMtl_PartNum')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Reinforcement Description" value={modifiedData[startIndex + index].JobMtl_Description} onChange={(e) => setreinforcementdescription(e, startIndex + index, 'JobMtl_Description')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Wty/Per" value={modifiedData[startIndex + index].JobMtl_QtyPer} onChange={(e) => setqty(e, startIndex + index, 'JobMtl_QtyPer')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="UOM" value={modifiedData[startIndex + index].JobMtl_IUM} onChange={(e) => setuom(e, startIndex + index, 'JobMtl_IUM')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Unit/Each" value={modifiedData[startIndex + index].JobHead_ProdQty} onChange={(e) => setunit(e, startIndex + index, 'JobHead_ProdQty')} /></td>
                            <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobEngineered} onChange={(e) => setengineered(e, startIndex + index, 'JobHead_JobEngineered')} /></td>
                            <td><input className='UpdateInput' type="checkbox" checked={modifiedData[startIndex + index].JobHead_JobReleased} onChange={(e) => setreleased(e, startIndex + index, 'JobHead_JobReleased')} /></td>
                            <td><input className='UpdateInput' type="text" placeholder="Site" value={modifiedData[startIndex + index].JobMtl_Plant} onChange={(e) => setsite(e, startIndex + index, 'JobMtl_Plant')} /></td>
                        </tr>
                    ))
                )}
            </>
        );
    };

    const goToNextPage = () => {
        const totalPages = Math.ceil(modifiedData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
        }
    };

    const renderPagination = () => {
        const totalPages = Math.ceil(modifiedData.length / itemsPerPage);
        const pageNumbers = [];

        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
        }

        return (
            <div className="pagination-batching">
                <button onClick={goToPreviousPage} disabled={currentPage === 1} className='pre-nex'>
                    Previous
                </button>
                {pageNumbers.slice(Math.max(currentPage - 2, 0), Math.min(currentPage + 1, totalPages)).map(number => (
                    <button key={number} className={currentPage === number ? 'active' : ''} onClick={() => setCurrentPage(number)}>
                        {number}
                    </button>
                ))}
                <button onClick={goToNextPage} disabled={currentPage >= totalPages} className='pre-nex'>
                   Next
                </button>
            </div>
        );
    };

    const toggleSearch = () => {
        setSearchOpen(!searchOpen);
    }

    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }

    const addNewRow = () => {
        const newRow = {
            JobHead_JobNum: '',
            PartLot_LotNum: '',
            JobMtl_PartNum: '',
            JobMtl_Description: '',
            JobMtl_QtyPer: '',
            JobMtl_IUM: '',
            JobHead_JobEngineered: true,
            JobHead_JobReleased: true,
            JobMtl_Plant: '',
        };
        setShowEmptyRow(true);
        setModifiedData([...modifiedData, newRow]);
        setApiData([...apiData, newRow]);
    };

    return (
        <div className={`card rebartable-BP ${isCollapsed ? 'collapsed' : ''}`}>
        {isLoading && (
            <div className="loading-overlay">
                <img src={GoCast} alt="Loading..." />
            </div>
        )}
            <div className="card-header-BP">
              
                <div className='box-1'>
          <button className="btn" id='toggle' onClick={() => setIsCollapsed(!isCollapsed)}>
                        <FontAwesomeIcon icon={isCollapsed ? faArrowDown : faArrowUp} />
                    </button>
                    <input type='text' placeholder=' Element ID' className='Search-Input-batching' onChange={handleFilterChange} />
              
              
          </div>
                <div className='ctrl-btns-rebar'>
                    <button className="btn" id='save' onClick={saveData}>
                        <FontAwesomeIcon icon={faSave} />
                    </button>
                    <Tooltip
                        anchorSelect="#save"
                        content="Save"
                        place='bottom'
                    />
                </div>
            </div>
            {!isCollapsed &&tableVisible && (
                <div className="card-body">
                  
                    <div className="table-responsive">
                        <div className="scrollable-table-body">
                            <table className="table table-bordered">
                                <thead className='table-primary'>
                                    <tr className='bg-primary text-white'>
                                        <th>Job</th>
                                        <th>Element </th>
                                        <th>Reinforcement ID</th>
                                        <th>Reinforcement Description</th>
                                        <th>Qty/Parent</th>
                                        <th>UOM</th>
                                        <th>Unit/Each</th>
                                        <th>Engineered</th>
                                        <th>Released</th>
                                        <th>Site</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderTableRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="pagination-batching">
                        <div className="items-per-page">
                            <label htmlFor="itemsPerPage">Show </label>
                            <select className='mx-1'
                                id="itemsPerPage"
                                value={itemsPerPage}
                                onChange={handleItemsPerPageChange}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>
                            <label htmlFor="itemsPerPage"> entries</label>
                        </div>
                        {renderPagination()}
                    </div>
             
                </div>
            )}
        </div>
    );
}

export default Rebar;
